
import Vue from 'vue';
import {
  Keyboard as VixKeyboard,
  Background as VixBackground,
  modal
} from '@mx/vix';
import { bridge, api } from '@/common';
import NewPassword from '@/components/NewPassword.vue';

export default Vue.extend({
  name: 'PayhashVerify',
  data() {
    return {
      passwordValue: '',
      errorInfoValue: this.errorInfo,
      isShowKeyboard: this.showKeyboard,
      paySafeInfo: {
        safeImgUrl: 'https://p1.meituan.net/pay/cf68119a3812a4e0c966dc8436d52efa2076.png'
      }
    };
  },
  props: {
    verifyUrl: {
      type: String,
      required: false
    },
    title: String,
    info: {
      type: String,
      required: false
    },
    errorInfo: {
      type: String,
      default: ''
    },
    showKeyboard: {
      type: Boolean,
      default: true
    }
  },
  components: {
    VixKeyboard,
    VixBackground,
    NewPassword
  },
  watch: {
    errorInfo(newValue, oldValue) {
      this.errorInfoValue = newValue;
    }
  },
  created() {
    bridge.setTitle('身份验证');
  },
  mounted() {
    this.$emit('mounted');
  },
  methods: {
    onComplete() {
      if (this.verifyUrl) {
        api
          .post(this.verifyUrl, {
            paypass: this.passwordValue
          })
          .then((data: any) => {
            this.$emit('success', {
              ...data,
              paypass: this.passwordValue
            });
          })
          .catch((error) => {
            this.errorInfoValue = error.message;
          });
      } else {
        this.$emit('success', {
          paypass: this.passwordValue
        });
      }
    }
  }
});
